import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { C12LinkedListEnhancedProps } from './C12LinkedListEnhanced.types';
import { LINKED_LIST_ENHANCED_ITEM_CONTAINER } from '@/shared/static';
import { LinkedListEnhancedProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from '@/shared/useConditionalRendering';
import { getDroplink } from '@/shared/param-utils';

export function GetLinkedListEnhancedModel(
  props?: C12LinkedListEnhancedProps
): LinkedListEnhancedProps {
  type t = LinkedListEnhancedProps;

  const { rendering, params, fields } = props || {};

  const { renderText, renderRichText, renderLink } = useConditionalRendering();

  return {
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    supportCopyBottom: renderRichText(fields?.SupportCopyBottom),
    cta: renderLink(fields?.Cta),
    linkedListItems: rendering && (
      <Placeholder name={LINKED_LIST_ENHANCED_ITEM_CONTAINER} rendering={rendering} />
    ),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'h2'),
    numColumns: getDroplink<t['numColumns']>(params?.Columns, '2'),
    ctaStyle: getDroplink<t['ctaStyle']>(params?.CtaStyle, 'outlined'),
  };
}
